import interceptedAxios from '../../../utils/interceptedAxios'
import { exportToExcel } from './JSONToExcel'

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

export interface ExportGraphRequest {
  assetId: string
  devices: any[]
  assets: any[]
}

export async function exportGraphDataService (
  startDateTime: string,
  endDateTime: string,
  type: string,
  requestParameter: ExportGraphRequest,
  onSuccess: (exportFile: any) => any,
  onFailure: (errorMessage: string) => any
): Promise<void> {
  const url = `/kpirest/api/v1/udp/tiq/dashboard/asset/graph/data/export?startDateTime=${startDateTime}&endDateTime=${endDateTime}&timeZone=${userTimezone}&dashboard=${type}`
  interceptedAxios
    .post(url, requestParameter, { timeout: 30000 })
    .then((response) => {
      if (response?.status === 200) {
        exportToExcel(response?.data?.data, type).then(() => {
          onSuccess(response)
        }).catch((error) => {
          onFailure(error)
        })
      } else {
        onFailure(response.data.error_message)
      }
    })
    .catch((error) => {
      onFailure(error)
    })
}
